import { Heading, MainContainer, Text } from "../../styles/views/aboutUs";

const AboutUs = () => {
  return (
    <MainContainer>
      <Heading>About Us</Heading>
      <Text>
        <div>
          Welcome to Hire Hub Solutions, your trusted partner in providing skilled foreign Expatriate (Expats) to
          businesses across the world in various industries. Established with the vision to bridge the talent gap, we
          specialize in connecting companies with top-tier professionals from around the world on a contract basis. Our
          mission is to help organizations scale efficiently while maintaining high standards of quality and compliance.
        </div>
        <div>
          We at Hire Hub Solutions can be your perfect expat recruitment agency for domestic and overseas recruitment.
          We will help you to finding the right candidate who will augment your national and international objectives.
          Our disciplined set of expat recruitment services will give you complete transparency with a wide range of
          options and benefits. We have the contact of some of the best talents who can serve your industries
          positively.
        </div>
        <div>
          At Hire Hub Solutions, we understand the challenges businesses face when it comes to recruitment and workforce
          management. Whether you need short-term, long-term, or seasonal manpower, our expertise in sourcing, vetting,
          and deploying foreign workers ensures that you get the right people for the job, on time and within budget.
        </div>
      </Text>
    </MainContainer>
  );
};

export default AboutUs;
